import {ofType} from "redux-observable";
import {catchError, map, switchMap, withLatestFrom} from "rxjs/operators";
import {from, of} from "rxjs";

import new_axios_instance from "../../axios_instance";
import {loadingOverlayActions, notifsActions, pianificazioneCalendarioActions} from '../../actions/index';
import * as pianificazioniCalendarioActionsType from '../../actions/actionsTypes/pianificazioneCalendarioActionsType';
import {createMessageRequestException, printOnlyInDevelopment} from "../../fanctionUtility";
import {dayJS} from "../../applicationConf";
import {getPianificazioneRicercaSuccess} from "../../actions/actions/pianificazioneCalendarioActions";


export const pianificazioniCalendarioCreate = (actions$, state$) =>
    actions$.pipe(
        ofType(pianificazioniCalendarioActionsType.PIANIFICAZIONE_CALENDARIO_CREATE),
        withLatestFrom(state$),
        map(([action, state]) =>
        {
            action.requestFiltri.idCorso = state.corso.corso.id
            return action.requestFiltri
        }),
        switchMap((requestFilters) =>
            from(new_axios_instance.post(`/v1/pianificazione/calendario/nuovo/crea`, Object.assign(requestFilters, {
                idCorso: requestFilters.idCorso,
                dataInizio: dayJS(requestFilters.date).startOf('month').format('YYYY-MM-DD'),
                dataFine: dayJS(requestFilters.date).endOf('month').format('YYYY-MM-DD')
            })))
                .pipe(
                    switchMap(response => of(
                        pianificazioneCalendarioActions.getPianificazioniFiltroSuccess(response.data),
                        loadingOverlayActions.hideLoadingOverlay()
                    ))
                ).pipe(
                catchError(err => {
                    printOnlyInDevelopment('Pianificazione Calendario ::', err);
                    const message = createMessageRequestException(err);

                    return of(
                        pianificazioneCalendarioActions.getPianificazioniFiltroFail(message),
                        notifsActions.notifError(message),
                        loadingOverlayActions.hideLoadingOverlay()
                    )
                })
            )
        )
    );


export const initCalendario = (actions$) =>
    actions$.pipe(
        ofType(pianificazioniCalendarioActionsType.INITIALIZATION_CALENDARIO),
        switchMap((action) => from(new_axios_instance.get(`/v1/pianificazione/corso/${action.idCorso}/calendario/recupera/estremi/mesi`))
            .pipe(
                map(({data: {meseInizio, meseFine, meseDaVisualizzare}}) =>
                    pianificazioneCalendarioActions.saveEstremi({
                        meseInizio,
                        meseFine,
                        meseDaVisualizzare
                    }))
            ).pipe(
                catchError(err => {
                    printOnlyInDevelopment('Pianificazione Calendario ::', err);
                    const message = createMessageRequestException(err);

                    return of(
                        pianificazioneCalendarioActions.getPianificazioniFiltroFail(message),
                        notifsActions.notifError(message),
                        loadingOverlayActions.hideLoadingOverlay()
                    )
                })
            )
        )
    );

export const getCalendarioPianificazioneRicerca = (actions$) =>
    actions$.pipe(
        ofType(pianificazioniCalendarioActionsType.PIANIFICAZIONE_CALENDARIO_RICERCA),
        switchMap((action) => {
                return from(new_axios_instance.get(`/v1/pianificazione/corso/${action.payload.idCorso}/data/${action.payload.data}`))
                    .pipe(
                        switchMap((response) => {
                            return of(
                                pianificazioneCalendarioActions.getPianificazioneRicercaSuccess(response.data),
                                loadingOverlayActions.hideLoadingOverlay()
                            )
                        })
                    ).pipe(
                    catchError(err => {
                        printOnlyInDevelopment('Pianificazione Calendario ::', err);
                        const message = createMessageRequestException(err);

                        return of(
                            pianificazioneCalendarioActions.getPianificazioneRicercaFail(message),
                            notifsActions.notifError(message),
                            loadingOverlayActions.hideLoadingOverlay()
                        )
                    })
                )
            }
        )
    );
